<script lang="ts">
  /**
   * One dot per section (h/p/r) plus a vegetable dot when the meal has a
   * vegetable line. Filled state comes straight from the API.
   */
  import type { DayMeal } from '../lib/types';

  let { meal }: { meal: DayMeal } = $props();
</script>

<div class="dots" aria-hidden="true">
  {#each meal.sections as s (s.id)}
    <i class="dot {s.kind}" class:on={s.filled}></i>
  {/each}
  {#if meal.vegTargetG !== null}
    <i class="dot v" class:on={meal.vegDone}></i>
  {/if}
</div>

<style>
  .dots { display: flex; gap: 4px; margin-top: 6px; }
  .dot {
    height: 6px;
    width: 22px;
    border-radius: 3px;
    background: var(--viisi-surface-3);
  }
  .dot.h.on { background: var(--viisi-c-carb); }
  .dot.p.on { background: var(--viisi-c-prot); }
  .dot.r.on { background: var(--viisi-c-fat); }
  .dot.v.on { background: var(--viisi-c-veg); }
</style>
